import { render, staticRenderFns } from "./BrandingLogo.vue?vue&type=template&id=1db55602&scoped=true&"
import script from "./BrandingLogo.vue?vue&type=script&lang=js&"
export * from "./BrandingLogo.vue?vue&type=script&lang=js&"
import style0 from "./BrandingLogo.vue?vue&type=style&index=0&id=1db55602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db55602",
  null
  
)

export default component.exports